import type { TextGetterProps } from '@ui-kit/components/formComponents/RadioCardSet/RadioCard/types'
import type {
  LayoutType,
  RadioCardVariant,
} from '@ui-kit/components/formComponents/RadioCardSet/types'

interface UseTextProps {
  layout: LayoutType
  variant?: RadioCardVariant
  isSmallDevice: boolean
  disabled: boolean | undefined
  isSelected: boolean
}

export const useTextProps = (props: UseTextProps) => {
  const color = props.variant === 'chip' && props.isSelected ? 'white' : undefined

  const getTitleProps = (): TextGetterProps => {
    if (props.isSelected) {
      return {
        emphasis: props.disabled ? 'low' : undefined,
        align: props.layout === 'compact' && !props.isSmallDevice ? 'center' : 'left',
        bold: true,
        color,
      }
    }

    return {
      emphasis: props.disabled ? 'low' : undefined,
      align: props.layout === 'compact' && !props.isSmallDevice ? 'center' : 'left',
      bold: undefined,
      color,
    }
  }

  const getSubtitleProps = (): TextGetterProps => {
    if (props.isSelected) {
      return {
        emphasis: props.disabled ? 'low' : undefined,
        align: props.layout === 'compact' && !props.isSmallDevice ? 'center' : 'right',
        bold: true,
        color,
      }
    }

    return {
      emphasis: props.disabled ? 'low' : 'medium',
      align: props.layout === 'compact' && !props.isSmallDevice ? 'center' : 'right',
      bold: undefined,
      color,
    }
  }

  const getDescriptionsProps = (): TextGetterProps => {
    return {
      emphasis: props.disabled ? 'low' : 'medium',
      align: props.layout === 'compact' && !props.isSmallDevice ? 'center' : 'left',
      bold: undefined,
      color,
    }
  }

  return { getTitleProps, getSubtitleProps, getDescriptionsProps }
}
